import { useSyncExternalStore } from 'react';

export const BP = { md: 768, lg: 1024, xl: 1280 } as const;

// Cache subscriber functions per query string so useSyncExternalStore receives a stable reference
const subscriberCache = new Map<string, (cb: () => void) => () => void>();

function getSubscriber(query: string) {
  let sub = subscriberCache.get(query);
  if (!sub) {
    sub = (cb: () => void) => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return () => {};
      }
      const mql = window.matchMedia(query);
      mql.addEventListener('change', cb);
      return () => mql.removeEventListener('change', cb);
    };
    subscriberCache.set(query, sub);
  }
  return sub;
}

function useMedia(query: string): boolean {
  return useSyncExternalStore(
    getSubscriber(query),
    () => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return false;
      }
      return window.matchMedia(query).matches;
    },
    () => false
  );
}

export const useIsMobile = () => useMedia(`(max-width: ${BP.md - 1}px)`);
export const useIsTablet = () => useMedia(`(min-width: ${BP.md}px) and (max-width: ${BP.xl - 1}px)`);
export const useIsWideDesktop = () => useMedia(`(min-width: ${BP.xl}px)`);
export const useIsTouch = () => useMedia('(pointer: coarse)');
export const useIsLandscapePhone = () => useMedia('(max-height: 500px) and (orientation: landscape)');

export function useBreakpoint(): { isDesktop: boolean; isMobile: boolean } {
  const isMobile = useIsMobile();
  return { isDesktop: !isMobile, isMobile };
}
